import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFlyableCms } from "./cms";

/** Site-wide top menu bar — kept identical in look + links to the Météo
 * dashboard nav (see meteo/src/App.vue): date, divider, pill tabs, amber active. */
const Bar = styled.nav`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px 10px;
  overflow-x: auto;
`;

const Today = styled.span`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  text-transform: capitalize;
  font-family: ui-monospace, "JetBrains Mono", monospace;
  flex-shrink: 0;
  margin-right: 4px;
`;

const Divider = styled.span`
  width: 1px;
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
  margin-right: 4px;
`;

const Tab = styled.a`
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;
  flex-shrink: 0;
  transition:
    color 0.15s ease,
    background 0.15s ease;

  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.05);
    text-decoration: none;
  }
`;

const ActiveTab = styled(Link)`
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 13px;
  font-weight: 600;
  color: #ffb13d;
  background: rgba(255, 122, 26, 0.1);
  box-shadow: 0 0 0 1px rgba(255, 122, 26, 0.25);
  text-decoration: none;
  flex-shrink: 0;

  &:hover {
    text-decoration: none;
  }
`;

export default function SiteNav() {
  const { t } = useTranslation();
  const cms = useFlyableCms();
  const today = new Date().toLocaleDateString("fr-CA", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
  return (
    <Bar aria-label={t("Site")}>
      <Today>{today}</Today>
      <Divider />
      <Tab href="https://paramoteur.treevolta.com">{cms.nav.ecole}</Tab>
      <Tab href="https://rag-rac.treevolta.com">Zone élèves</Tab>
      {/* Météo dashboard is the site root (a separate app). */}
      <Tab href="/">{cms.nav.weather}</Tab>
      {/* Flyable app lives here, under /meteo/ (router basename) — active. */}
      <ActiveTab to="/">{cms.nav.flyable}</ActiveTab>
    </Bar>
  );
}
